import React from 'react';
import { formatTime } from '../../../../utils/timeCalculations';
import { SummaryBox, Comment, SummaryWrapper } from './styled';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

export const SummaryWorkLogs = ({totalNonServiceTime, selectedMonth, selectedYear, data, showAcceptedTasks}) => {
  const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];

  const serviceTimeLimit = data?.result?.apiUsageInfoDto?.serviceTimeLimit || 0;
  const savedServiceTime = data?.result?.apiUsageInfoDto?.timeSavedInPreviousMonth || 0;
  const worklogSummaryTime = data?.result?.worklogSummary?.sumTimeInSecound || 0;
  const currentMonthYear = format(new Date(), 'LLLL yyyy', { locale: pl });

  return (
    <SummaryWrapper>
    <SummaryBox>
      <h2>Dostępny czas serwisowy ({currentMonthYear}):</h2>
      <p>Miesięczny czas serwisowy: <strong>{serviceTimeLimit ? `${serviceTimeLimit}h` : "Brak danych"}</strong></p>
      <p>Zaoszczędzony czas serwisowy: <strong>{formatTime(savedServiceTime)}</strong></p>
      {!showAcceptedTasks && (
        <>
          <h2>Podsumowanie okresu:</h2>
          <p>Analizowany okres: <strong>{months[selectedMonth]} {selectedYear}</strong></p>
          <p>Zarejestrowany czas SERWISOWY: <strong>{formatTime(worklogSummaryTime)}</strong></p>
          <p>Zarejestrowany czas NIESERWISOWY: <strong>{formatTime(totalNonServiceTime)}</strong></p>
          
        </>
      )}
    </SummaryBox>
      <Comment>
        <strong>Uwaga! </strong>
        Zarejestrowany czas w zgłoszeniach oznaczonych etykietą <strong>"NIESERWISOWE" </strong>nie jest uwzględniany w łącznym czasie serwisowym wykorzystanym przez Klienta.
      </Comment>

    </SummaryWrapper>
  );
};
